import React, { useEffect, useState } from "react";
import { Prompt } from "react-router-dom";
import {
  Box,
  Card,
  TextField,
  Typography,
  CardContent,
  Grid,
  Divider,
  styled,
  Paper,
} from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import DeleteIcon from "@material-ui/icons/Delete";
import { useFormik } from "formik";
import moment from "moment";
import "moment-timezone";
import UseWindowDimensions from "src/common/utils/getWindowDimensions";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import CommonButton from "src/components/CommonButton/CommonButton";
import NewCommonButton from "src/components/CommonButton/NewCommonButton";

import TabHeader from "src/components/TabHeader/TabHeader";
import { CommercialRoute } from "../../commercial.routes";
import { columns } from "./components/columns";
import * as Yup from "yup";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import {
  selectLoader,
  selectPaymentTypes,
  selectWeightScanTypes,
  selectPaymentTypeDetail,
  addPaymentAction,
  removeGridItem,
  removeAllPayments,
} from "src/app-redux/commercial/commercialSlice";
import { useAppDispatch, useAppSelector } from "src/app-redux/hooks";
import {
  getPaymentTypesDropdownAction,
  getPaymentTypeDetailsAction,
  postTerminalChargesWholeRecordAction,
} from "src/app-redux/commercial/actions/commercialActions";
import { getAllTaxTypes } from "src/app-redux/configuration/actions/configurationActions";
import { selectAllTaxTypeRowsList } from "src/app-redux/configuration/configurationSlice";
import { useStyles } from "./components/style";
import { numberFormatting } from "src/common/utils/helpers";
import Checkbox from "@mui/material/Checkbox";
import TransitionDialog from "src/components/AlertDialog/TransitionDialog";
import CommonMaterialGrid from "src/components/CommonXGrid/CommonMaterialGrid";
import { CheckCircle, Cancel } from "@material-ui/icons";
import CommonLoader from "src/components/Loader/CommonLoader";

interface Props {}

export function TerminalCharges({}: Props): React.ReactElement {
  const isExportString = localStorage.getItem("isAllowToExportData");
  const isExport = isExportString === "true";
  const classes = useStyles();
  const [displayColumns, setDisplayColumns] = React.useState<any>(columns);
  const moduleName = CommercialRoute.title;
  const pageHeading = CommercialRoute.subRoutes ? CommercialRoute.subRoutes[0].title : "Page Title";
  const [loader2, setLoader2] = useState<any>(false);
  const [isOtherPayment, setIsOtherPayment] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const allTaxTypeRows = useAppSelector(selectAllTaxTypeRowsList);
  const [vehicleRegNumberArr, setvehicleRegNumberArr] = React.useState<any[]>([]);
  const [vehicleRegNumber, setVehicleRegNumber] = React.useState<any>(0);
  const [isOpenDublicateDailog, setIsOpenDublicateDailog] = useState<boolean>(false);
  const [isVehicleAdd, setVehicleAdd] = useState(false);
  /* AXIOS Calls */
  const getVehicleByRegistrationNoAction = async (queryString: string) => {
    let results: any = [];
    results = await fetchWrapper.get(
      `search-vehicles-by-vehicle-registration-number/${queryString}`
    );
    if (results.isSuccess) {
      setvehicleRegNumberArr(results.value);
    }
    return;
  };

  const getVehicleStatusByVehicleId = async (id: number) => {
    let results: any = [];
    try {
      setLoader2(true);
      results = await fetchWrapper.get(`get-vehicle-status-id-by-vehicle-Id/${id}`);
      if (results.isSuccess == true) {
        setcargoType(results.value.cargoTypeName);
        setconsignmentType(results.value.consignmentTypeName);
        setvehicleType(results.value.vehicleType);
        setentryDateTime(results.value.dateTime);
        setScanning(results.value.isScanComplete);
        setWeight(results.value.isWeightDone);
      }
      setLoader2(false);
      return;
    } catch (error: any) {
      setLoader2(false);
    }
  };
  /*./AXIOS Calls */

  const [isOpenDeleteDailog, setIsOpenDeleteDailog] = useState<boolean>(false);
  const [deleteGridItemId, setDeleteGridItemId] = useState<any>("");
  const handleCloseDeleteDialog = () => {
    setIsOpenDeleteDailog(false);
  };
  const handleDeleteDialog = () => {
    setIsOpenDeleteDailog(false);
    dispatch(removeGridItem(deleteGridItemId));
  };

  const handleRemoveGridItem = (params: any) => {
    setIsOpenDeleteDailog(true);
    setDeleteGridItemId(params.id);
  };

  useEffect(() => {
    const transformedColumns: any = columns.map((column: any) =>
      column.accessorKey === "actionButtons"
        ? {
            ...column,
            Cell: function customCell({ row }: any) {
              return (
                <>
                  <NewCommonButton
                    icon={<DeleteIcon />}
                    isDelete={true}
                    onClick={() => {
                      handleRemoveGridItem(row.original);
                    }}
                  >
                    Delete
                  </NewCommonButton>
                </>
              );
            },
          }
        : column
    );
    setDisplayColumns(transformedColumns);
  }, []);

  const { height } = UseWindowDimensions();
  let dppr = 10;
  if (height > 700 && height < 900) {
    dppr = 15;
  } else if (height > 900) {
    dppr = 25;
  } else {
    dppr = 10;
  }
  const validationSchema = Yup.object().shape({
    paymentType: Yup.string().required("This field is required"),
    paymentQuantity: Yup.number()
      .required("This field is required")
      .max(10000000000, "Maximum 10 digits are allowed")
      .test(
        "Is positive?",
        "The Quantity must be equal or greater than 0.",
        (value: any) => value > -1
      ),
    charges: Yup.number()
      .required("This field is required")
      .max(1000000000000000, "Maximum 15 digits are allowed")
      .test(
        "Is positive?",
        "The Charges must be equal or greater than 0.",
        (value: any) => value > -1
      ),
    remarks: Yup.string().max(3000, "Maximum 3000 characters allowed"),
  });
  const formik = useFormik({
    initialValues: {
      currency: "PKR",
      paymentTypeId: 0,
      paymentType: "",
      isFixed: 0,
      otherPaymentName: "",
      paymentQuantity: 1,
      charges: "",
      remarks: "",
      taxTypeId: "",
      tax: { taxType: "", taxRate: 0 },
    },
    validationSchema: validationSchema,
    onSubmit: async (values: any, actions) => {
      if (extraValidations(values, isOtherPayment) === false) return;
      const temp = values.paymentType;
      if (isOtherPayment) values.paymentType = values.otherPaymentName;

      const res: any = await dispatch(addPaymentAction(values));
      setVehicleAdd(true);
      if (res.payload) {
        values.paymentType = temp;
        actions.setSubmitting(false);
        setIsDirty(false);
        resetFilterForm();
        return;
      }
    },
  });

  const extraValidations = (values: any, isOtherPayment: boolean) => {
    if (isOtherPayment) {
      if (values.otherPaymentName === "") {
        dispatch(
          addNotificationAction({
            message: "Other Payment Name is Required",
            options: { variant: "error" },
          })
        );
        return false;
      }
    }
    if (gatePassId === 0 || gatePassId === "" || gatePassId === undefined) {
      const message =
        "Please select Vehicle Number, Or the selected Vehicle is already been checkedout.";
      dispatch(
        addNotificationAction({
          message: message,
          options: { variant: "error" },
        })
      );
      return false;
    }
    return true;
  };
  const resetWholePage = () => {
    setVehicleAdd(false);
    formik.setFieldValue("remarks", "");
    formik.setFieldValue("taxTypeId", "");
    formik.setFieldValue("tax", { taxType: "", taxRate: 0 });
    setatCommercialStation(false);
    setvehicleRegNumberArr([]);
    dispatch(removeAllPayments());
    setApiSubmitRecordData([]);
    setFilterGridRecord([]);
    setTotalAmount(0);
    setcargoType("");
    setconsignmentType("");
    setvehicleType("");
    setentryDateTime("");
  };
  const resetFilterForm = () => {
    formik.resetForm();
    formik.setValues({
      ...formik.initialValues,
      remarks: formik.values.remarks,
      taxTypeId: formik.values.taxTypeId,
      tax: formik.values.tax,
    });
    setIsDirty(false);
    setIsOtherPayment(false);
  };
  // New
  const [totalAmount, setTotalAmount] = useState(0);

  const calculateTax = () => {
    const taxRate = Number(formik.values.tax?.taxRate) || 0;
    return (Number(totalAmount) * taxRate) / 100;
  };
  const [filterGridRecord, setFilterGridRecord] = useState<any>([]);
  const [apiSubmitRecordData, setApiSubmitRecordData] = useState<any>([]);
  const [vehicleId, setVehicleId] = React.useState<any>(0);
  const [gatePassId, setGatePassId] = React.useState<any>(0);

  const loading = useAppSelector(selectLoader);
  const paymentTypes: any[] = useAppSelector(selectPaymentTypes);
  const paymentTypeDetail = useAppSelector(selectPaymentTypeDetail);
  const weightScanTypesRecord = useAppSelector(selectWeightScanTypes);
  const [paymentTypesList, setPaymentTypesList] = useState<any>([]);
  const GroupHeader = styled("div")(({ theme }) => ({
    position: "sticky",
    top: "-8px",
    padding: "4px 10px",
    fontWeight: "bold",
    backgroundColor: "#E7E7E7",
  }));

  const GroupItems = styled("ul")({
    padding: 0,
  });

  useEffect(() => {
    const list = [
      ...paymentTypes.filter((item: any) => item.isFixed == 1),
      ...paymentTypes.filter((item: any) => item.isFixed == 0),
    ];
    setPaymentTypesList(
      list.concat({
        amount: 0,
        currency: "PKR",
        id: -1,
        isActive: true,
        isFixed: 0,
        name: "Other",
      })
    );
  }, [paymentTypes]);

  const recordSaveHandler = () => {
    let count = 0;
    if (weightScanTypesRecord) {
      const newData = weightScanTypesRecord.map((item: any, index: any) => {
        count += item.charges * item.paymentQuantity;
        return {
          ...item,
          charges: `${item.currency} ${numberFormatting(item.charges * item.paymentQuantity)} `,
        };
      });
      setTotalAmount(count);
      setFilterGridRecord(newData);
      const newData2 = weightScanTypesRecord.map((item: any, index: any) => {
        return {
          ...item,
          charges: `${item.charges * item.paymentQuantity}`,
        };
      });
      setApiSubmitRecordData(newData2);
    }
  };

  useEffect(() => {
    if (paymentTypes.length === 0) dispatch(getPaymentTypesDropdownAction());
    dispatch(getAllTaxTypes(1));
  }, [vehicleId]);

  useEffect(() => {
    if (!Array.isArray(allTaxTypeRows) || allTaxTypeRows.length === 0) return;
    if (formik.values.taxTypeId !== "" && formik.values.taxTypeId != null) return;

    const saleTaxRow: any = allTaxTypeRows.find(
      (t: any) =>
        String(t?.taxType || "")
          .trim()
          .toLowerCase() === "sale tax"
    );
    if (!saleTaxRow) return;

    formik.setFieldValue("taxTypeId", saleTaxRow.id);
    formik.setFieldValue("tax", saleTaxRow);
  }, [allTaxTypeRows, formik.values.taxTypeId]);
  useEffect(() => {
    if (paymentTypeDetail) formik.setFieldValue("charges", paymentTypeDetail?.amount);
  }, [paymentTypeDetail]);

  useEffect(() => {
    const isPaymentExist = weightScanTypesRecord?.filter(
      (rec: any) => rec.paymentTypeId == formik.values.paymentTypeId
    ).length;
    if (isPaymentExist > 1) {
      setIsOpenDublicateDailog(true);
      return;
    }
    recordSaveHandler();
  }, [weightScanTypesRecord]);

  useEffect(() => {
    // Unmount all Record
    return resetWholePage();
  }, []);

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [dialogContent, setDialogContent] = useState<any>();
  const handleCloseDialog = () => {
    setIsOpen(false);
  };

  const handleConfirmDialog = async () => {
    setIsOpen(false);
    if (gatePassId === 0 || gatePassId === "" || gatePassId === undefined) {
      dispatch(
        addNotificationAction({
          message: "Please select Vehicle Number!",
          options: { variant: "error" },
        })
      );
      return;
    }
    const taxRate = Number(formik.values.tax?.taxRate) || 0;
    const taxAmout = calculateTax();
    const totalNetAmount = totalAmount + taxAmout;
    const record = {
      gatePassId: gatePassId,
      atCommercialStation: atCommercialStation,
      gatePassPaymentDetail: apiSubmitRecordData,
      remarks: formik.values.remarks,
      taxId: (() => {
        const raw = formik.values.taxTypeId;
        if (raw === "" || raw === null || raw === undefined) return 0;
        const n = Number(raw);
        return Number.isFinite(n) && n > 0 ? n : 0;
      })(),
      taxAmount: taxAmout,
      taxRate: taxRate,
      netAmount: totalNetAmount,
    };
    const res: any = await dispatch(postTerminalChargesWholeRecordAction(record));
    if (res?.payload) {
      resetWholePage();
      formik.setFieldValue("remarks", "");
    }
  };

  const submitCompletePage = async () => {
    if (!apiSubmitRecordData.length) {
      dispatch(
        addNotificationAction({
          message: "Please add some Payment record!",
          options: { variant: "error" },
        })
      );
      return;
    }

    let data = "";
    apiSubmitRecordData.forEach((item: any) => {
      data = data.concat(
        `${item.paymentType}: ${item.currency} ${numberFormatting(item.charges)} #`
      );
    });
    const taxAmout = calculateTax();
    const totalNetAmount = totalAmount + taxAmout;
    const taxLabel = formik.values.tax?.taxType
      ? `${formik.values.tax.taxType} (${formik.values.tax.taxRate}%)`
      : "Tax";
    data = data.concat(
      ` Total Charges: ${formik.values.currency} ${numberFormatting(totalAmount)}#`
    );
    data = data.concat(
      ` ${taxLabel} Amount: ${formik.values.currency} ${numberFormatting(taxAmout)}#`
    );
    data = data.concat(
      ` Total Net Amount: ${formik.values.currency} ${numberFormatting(totalNetAmount)}`
    );

    setDialogContent(data);
    setIsOpen(true);
  };

  // Show prompt if the form is fully or partially filled and user wants to navigate away
  const [isDirty, setIsDirty] = React.useState<boolean>(false);
  useEffect(() => {
    window.onbeforeunload = function (e: Event) {
      if (isDirty) {
        e.preventDefault();
        return "Changes you made may not be saved.";
      }
    };
  }, [isDirty]);
  function handleChange(e: any) {
    // Textfield ==>> e.target.value
    // Checkbox / Switch ==>> e.target.checked !== e.target._wrapperState.initialChecked
    formik.handleChange(e);
    e.target.value || JSON.stringify(formik.values) !== JSON.stringify(formik.initialValues)
      ? setIsDirty(true)
      : setIsDirty(false);
  }

  const [atCommercialStation, setatCommercialStation] = useState<boolean>(false);
  const [vehicleNumberLength, setVehicleNumberLength] = useState<number>(0);
  const [scanning, setScanning] = useState<any>();
  const [weight, setWeight] = useState<any>();
  const [cargoType, setcargoType] = useState<string>("");
  const [consignmentType, setconsignmentType] = useState<string>("");
  const [vehicleType, setvehicleType] = useState<string>("");
  const [entryDateTime, setentryDateTime] = useState<string>("");

  const listener = (e: any) => {
    if (
      (e.key === "s" || e.key === "S") &&
      (navigator.platform.match("Mac") ? e.metaKey : e.ctrlKey)
    ) {
      e.preventDefault();
      !loading && submitCompletePage();
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, [apiSubmitRecordData, loading]);

  const exportHandler = async (row: any) => {
    dispatch(
      addNotificationAction({
        message: "Your download will begin shortly",
        options: { variant: "success" },
      })
    );
    const exportedRecords = await row?.map((data: any) => {
      return {
        "Type of Payment": data?.paymentType,
        Quantity: data?.paymentQuantity,
        "Total Charges": `PKR ${data?.charges?.toLocaleString(undefined, {
          maximumFractionDigits: 2,
        })}`,
      };
    });
    return exportedRecords;
  };

  const handleCloseDublicateDialog = () => {
    setIsOpenDublicateDailog(false);
    const deleteGridItemId: any = weightScanTypesRecord[weightScanTypesRecord.length - 1];
    dispatch(removeGridItem(deleteGridItemId.id));
  };

  const handleSaveDublicateDialog = async () => {
    setIsOpenDublicateDailog(false);
    recordSaveHandler();
  };

  return (
    <div>
      {/* If prompt, when navigating to another page inside the app */}
      <Prompt when={isDirty} message="Changes you made may not be saved." />
      <TabHeader module={moduleName} heading={pageHeading} link={CommercialRoute.path} />
      <Backdrop className={classes.backdrop} open={loading || loader2}>
        <CommonLoader />
      </Backdrop>
      <Box m={2} />
      <Card>
        <CardContent className={classes.cardMain}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Grid item md={9}>
              <Box mt={1} mb={2}>
                <Typography className={classes.pageHeading}> {pageHeading} </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={3} direction="row">
              <Box textAlign="right" mt={1} mb={1}>
                <CommonButton cssClass="customSubmitBtn" onClick={() => resetWholePage()}>
                  Reset
                </CommonButton>
                <CommonButton
                  cssClass="customSubmitBtn"
                  isGreen
                  onClick={() => submitCompletePage()}
                >
                  Save
                </CommonButton>
              </Box>
            </Grid>
          </Grid>
          <Box style={{ marginBottom: "10px" }}>
            <Divider />
          </Box>
          <>
            <Grid spacing={2} container direction="row">
              <Grid item xs={12} md={3} container direction="row">
                <Grid item xs={12}>
                  <Box>
                    <CommonAutoCompleteField
                      disabled={isVehicleAdd}
                      cssClassName="customTextField"
                      label="Vehicle Number"
                      placeholder="Vehicle Number"
                      name="registrationNumber"
                      optionsType={vehicleRegNumberArr}
                      getOptionLabel={(option) => option.registrationNumber}
                      required
                      value={
                        vehicleRegNumberArr.find(
                          (st: any) => st.registrationNumber === vehicleRegNumber
                        ) || null
                      }
                      onChange={(option: any) => {
                        if (option && option.registrationNumber !== "" && option.vehicleId !== 0) {
                          getVehicleStatusByVehicleId(option.vehicleId);
                          setVehicleId(option.vehicleId);
                          setGatePassId(option.gatePassId);
                          setVehicleRegNumber(option.registrationNumber);
                          handleChange({ target: { value: option.vehicleId } });
                        } else {
                          setVehicleRegNumber("");
                          handleChange({ target: { value: null } });
                        }
                      }}
                      onKeyUp={(e: any) => {
                        setVehicleNumberLength(e.target.value.length);

                        if (e.target.value.length == 2 && vehicleNumberLength < 2) {
                          getVehicleByRegistrationNoAction(e.target.value);
                          return;
                        }
                      }}
                      onKeyDownCapture={(e: any) => {
                        if (/[^A-Za-z0-9\d]/.test(e.key)) e.preventDefault();
                        else handleChange(e);
                      }}
                      onPaste={(e: any) => {
                        if (/[^A-Za-z0-9\d]/.test(e.clipboardData.getData("text"))) {
                          e.preventDefault();
                          return;
                        }

                        if (e.clipboardData.getData("text").length >= 2)
                          getVehicleByRegistrationNoAction(e.clipboardData.getData("text"));
                      }}
                    />
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={Boolean(atCommercialStation)}
                          onChange={(event) => {
                            setatCommercialStation(event.target.checked);
                          }}
                          name="atCommercialStation"
                          color="primary"
                        />
                      }
                      label="Vehicle at Commercial Station"
                    />
                  </Box>
                </Grid>
              </Grid>
              <Grid item xs={12} md={9}>
                <Paper
                  elevation={1}
                  variant="outlined"
                  style={{ padding: "20px", backgroundColor: "rgb(0 0 0 / 7%)", border: "none" }}
                >
                  <Grid spacing={2} container direction="row" justifyContent="space-between">
                    <Grid
                      item
                      xs={12}
                      md={4}
                      container
                      direction="row"
                      justifyContent="space-between"
                    >
                      <Grid item xs={4} md={5} lg={4}>
                        <Typography className={classes.readOnyTitle}>Scanned:</Typography>
                      </Grid>
                      <Grid item xs={7} md={6} lg={7}>
                        {/* <Typography>{scanning || "-"}</Typography> */}
                        {scanning == 1 ? (
                          <Typography style={{ color: "#72CA00" }}>
                            <CheckCircle />
                          </Typography>
                        ) : scanning == 0 ? (
                          <Typography style={{ color: "red" }}>
                            <Cancel />
                          </Typography>
                        ) : (
                          <Typography>-</Typography>
                        )}
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={4}
                      container
                      direction="row"
                      justifyContent="space-between"
                    >
                      <Grid item xs={4} md={5} lg={4}>
                        <Typography className={classes.readOnyTitle}>Weight:</Typography>
                      </Grid>
                      <Grid item xs={7} md={6} lg={7}>
                        {weight == 1 ? (
                          <Typography style={{ color: "#72CA00" }}>
                            <CheckCircle />
                          </Typography>
                        ) : weight == 0 ? (
                          <Typography style={{ color: "red" }}>
                            <Cancel />
                          </Typography>
                        ) : (
                          <Typography>-</Typography>
                        )}
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={4}
                      container
                      direction="row"
                      justifyContent="space-between"
                    >
                      <Grid item xs={4} md={5} lg={4}>
                        <Typography className={classes.readOnyTitle}>Vehicle Type:</Typography>
                      </Grid>
                      <Grid item xs={7} md={6} lg={7}>
                        <Typography>{vehicleType || "-"}</Typography>
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={4}
                      container
                      direction="row"
                      justifyContent="space-between"
                    >
                      <Grid item xs={4} md={6} lg={4}>
                        <Typography className={classes.readOnyTitle}>Consignment:</Typography>
                      </Grid>
                      <Grid item xs={7} md={5} lg={7}>
                        <Typography>{consignmentType || "-"}</Typography>
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={4}
                      container
                      direction="row"
                      justifyContent="space-between"
                    >
                      <Grid item xs={4} md={5} lg={4}>
                        <Typography className={classes.readOnyTitle}>Cargo:</Typography>
                      </Grid>
                      <Grid item xs={7} md={6} lg={7}>
                        <Typography>{cargoType || "-"}</Typography>
                      </Grid>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={4}
                      container
                      direction="row"
                      justifyContent="space-between"
                    >
                      <Grid item xs={4} md={5} lg={4}>
                        <Typography className={classes.readOnyTitle}>Entry:</Typography>
                      </Grid>
                      <Grid item xs={7} md={6} lg={7}>
                        <Typography>
                          {entryDateTime ? moment(entryDateTime).format("DD-MM-YYYY hh:mm a") : "-"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
              {/* <Grid item xs={12} md={3}>
                <Box>
                  <TextField
                    className="customTextField"
                    size="small"
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Vehicle Type"
                    name="vehicleType"
                    placeholder="Vehicle Type"
                    disabled={true}
                    value={vehicleType}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={3}>
                <Box>
                  <TextField
                    className="customTextField"
                    size="small"
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Type of Consignment"
                    name="consignmentType"
                    placeholder="Type of Consignment"
                    disabled={true}
                    value={consignmentType}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={3}>
                <Box>
                  <TextField
                    className="customTextField"
                    size="small"
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Type of Cargo"
                    name="cargoType"
                    placeholder="Type of Cargo"
                    disabled={true}
                    value={cargoType}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={3}>
                <Box>
                  <TextField
                    className="customTextField"
                    size="small"
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Vehicle Entry Date/Time"
                    name="entryDateTime"
                    placeholder="Vehicle Entry Date/Time"
                    disabled={true}
                    value={
                      entryDateTime
                        ? moment(entryDateTime).format("DD-MM-YYYY hh:mm a")
                        : entryDateTime
                    }
                  />
                </Box>
              </Grid> */}
            </Grid>
          </>
          <Box style={{ marginTop: "30px", marginBottom: "30px" }}>
            <Divider />
          </Box>
          <>
            <Grid spacing={2} container direction="row">
              <Grid item xs={6} md={3} lg={2}>
                <Box>
                  <CommonAutoCompleteField
                    cssClassName="customTextField"
                    error={formik.touched.paymentType && Boolean(formik.errors.paymentType)}
                    helperText={formik.touched.paymentType && formik.errors.paymentType}
                    label="Type of Payment"
                    placeholder="Type of Payment"
                    name="paymentType"
                    optionsType={paymentTypesList}
                    getOptionLabel={(option) => option.name}
                    groupBy={(option) => option.isFixed}
                    renderGroup={(params) => (
                      <li key={params.key}>
                        <GroupHeader>
                          {Number(params.group) == 0 ? "Variable Charges" : "Fixed Charges"}
                        </GroupHeader>
                        <GroupItems>{params.children}</GroupItems>
                      </li>
                    )}
                    required
                    value={
                      paymentTypesList.find((st: any) => st.name === formik.values.paymentType) ||
                      null
                    }
                    onChange={(option: any) => {
                      if (option && option.id !== 0) {
                        formik.setFieldValue("paymentTypeId", option.id);
                        formik.setFieldValue("paymentType", option.name);
                        formik.setFieldValue("isFixed", option.isFixed);
                        handleChange({ target: { value: option.name } });
                        if (option.name === "Other") {
                          setIsOtherPayment(true);
                        } else {
                          dispatch(getPaymentTypeDetailsAction(option.id));
                          setIsOtherPayment(false);
                        }
                      } else {
                        handleChange({ target: { value: null } });
                      }
                    }}
                  />
                </Box>
              </Grid>
              <Grid
                item
                xs={6}
                md={3}
                lg={2}
                className={!isOtherPayment ? classes.hideDatesGrid : ""}
              >
                <TextField
                  className="customTextField"
                  required
                  size="small"
                  fullWidth
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  label="Other Payment"
                  name="otherPaymentName"
                  placeholder="Other Payment"
                  disabled={false}
                  value={formik.values.otherPaymentName}
                  onChange={handleChange}
                  error={formik.touched.otherPaymentName && Boolean(formik.errors.otherPaymentName)}
                  helperText={formik.touched.otherPaymentName && formik.errors.otherPaymentName}
                />
              </Grid>
              <Grid item xs={6} md={2}>
                <Box>
                  <TextField
                    className="customTextField"
                    required
                    type="number"
                    InputProps={{ inputProps: { min: 0 } }}
                    size="small"
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Quantity"
                    name="paymentQuantity"
                    placeholder="Quantity"
                    disabled={false}
                    onKeyDown={(evt) =>
                      (evt.key === "e" || evt.key === ".") && evt.preventDefault()
                    }
                    value={formik.values.paymentQuantity}
                    onChange={handleChange}
                    onPaste={(e: any) => {
                      if (/[^0-9]/.test(e.clipboardData.getData("text"))) e.preventDefault();
                    }}
                    error={formik.touched.paymentQuantity && Boolean(formik.errors.paymentQuantity)}
                    helperText={formik.touched.paymentQuantity && formik.errors.paymentQuantity}
                  />
                </Box>
              </Grid>
              <Grid item xs={6} md={2}>
                <Box>
                  <TextField
                    className="customTextField"
                    required
                    type="number"
                    InputProps={{ inputProps: { min: 0 } }}
                    size="small"
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onKeyDown={(evt) =>
                      (evt.key === "e" || evt.key === ".") && evt.preventDefault()
                    }
                    label="Charges"
                    name="charges"
                    placeholder="Charges"
                    // placeholder="Charges Per Quantity"
                    disabled={false}
                    value={formik.values.charges}
                    onChange={handleChange}
                    onPaste={(e: any) => {
                      if (/[^0-9]/.test(e.clipboardData.getData("text"))) e.preventDefault();
                    }}
                    error={formik.touched.charges && Boolean(formik.errors.charges)}
                    helperText={formik.touched.charges && formik.errors.charges}
                  />
                </Box>
              </Grid>
              <Grid item xs={6} md={2}>
                <Box>
                  <TextField
                    className="customTextField"
                    size="small"
                    fullWidth
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Currency"
                    name="currency"
                    disabled={true}
                    value={formik.values.currency}
                    onChange={handleChange}
                    error={formik.touched.currency && Boolean(formik.errors.currency)}
                    helperText={formik.touched.currency && formik.errors.currency}
                  />
                </Box>
              </Grid>
              {/* <Grid item xs={12} md={!isOtherPayment ? 12 : 4} lg={!isOtherPayment ? 2 : 1}></Grid> */}
              <Grid
                item
                xs={!isOtherPayment ? 12 : 6}
                md={!isOtherPayment ? 3 : 12}
                lg={!isOtherPayment ? 4 : 2}
                direction="row"
              >
                <Box
                  textAlign="inherit"
                  mt={1}
                  mb={1}
                  className="terminalChargesSearchBtns headerButtonsConfig"
                  style={{ float: "right" }}
                >
                  <CommonButton
                    cssClass="customSubmitBtn"
                    onClick={() => {
                      resetFilterForm();
                    }}
                  >
                    Reset
                  </CommonButton>
                  <CommonButton
                    cssClass="customSubmitBtn"
                    isGreen
                    onClick={() => formik.submitForm()}
                  >
                    Add
                  </CommonButton>
                </Box>
              </Grid>
            </Grid>
          </>
          <div className={classes.grid}>
            <CommonMaterialGrid
              rows={filterGridRecord}
              columns={displayColumns}
              // loader={loader2}
              defaultPerPageRecord={50}
              height={450}
              isExport={isExport}
              exportHandler={exportHandler}
              filename={`Commercial_Terminal_charges_${Date.now()}`}
            />
          </div>
          <Grid spacing={2} container direction="row">
            <Grid item xs={12} md={6} className={classes.remarksDiv}>
              <Box>
                <TextField
                  className="customTextField"
                  size="small"
                  fullWidth
                  multiline
                  rows={1}
                  rowsMax={5}
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  label="Remarks"
                  name="remarks"
                  placeholder="Remarks"
                  disabled={false}
                  value={formik.values.remarks}
                  onChange={handleChange}
                  error={formik.touched.remarks && Boolean(formik.errors.remarks)}
                  helperText={formik.touched.remarks && formik.errors.remarks}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={6} className={classes.remarksDiv}>
              <Box>
                <CommonAutoCompleteField
                  cssClassName="customTextField"
                  label="Tax Type (%)"
                  placeholder="Select Tax Type"
                  name="taxTypeId"
                  optionsType={allTaxTypeRows}
                  getOptionLabel={(option) =>
                    `${option.taxType.toString()} - ${option?.taxRate.toString()}%`
                  }
                  onChange={(row: any) => {
                    formik.setFieldValue("taxTypeId", row?.id);
                    formik.setFieldValue("tax", row);
                  }}
                  value={allTaxTypeRows.find((st: any) => st.id == formik.values.taxTypeId) || null}
                  error={formik.touched.taxTypeId && Boolean(formik.errors.taxTypeId)}
                  helperText={formik.touched.taxTypeId && formik.errors.taxTypeId}
                />
              </Box>
            </Grid>
          </Grid>
          {(() => {
            const taxAmout = calculateTax();
            const totalNetAmount = totalAmount + taxAmout;
            const taxRateLabel = formik.values.tax?.taxRate
              ? `${formik.values.tax.taxRate}%`
              : "0%";

            return (
              <Grid
                item
                md={12}
                container
                className={`${classes.totalDiv} commercialChargeTotalDiv`}
                alignItems="center"
              >
                <Grid item md={4} sm={4} xs={12}>
                  <Typography variant="h6" className={classes.subHeadings}>
                    Total:{" "}
                    <span className={classes.totalVal}>
                      {`${formik.values.currency} ${numberFormatting(totalAmount)}`}
                    </span>
                  </Typography>
                </Grid>

                <Grid item md={4} sm={4} xs={12}>
                  <Typography variant="h6" className={classes.subHeadings}>
                    Tax Amount ({taxRateLabel}):{" "}
                    <span className={classes.totalVal}>
                      {`${formik.values.currency} ${numberFormatting(taxAmout)}`}
                    </span>
                  </Typography>
                </Grid>

                <Grid item md={4} sm={4} xs={12}>
                  <Typography variant="h6" className={classes.subHeadings}>
                    Total Net Amount:{" "}
                    <span className={classes.totalVal}>
                      {`${formik.values.currency} ${numberFormatting(totalNetAmount)}`}
                    </span>
                  </Typography>
                </Grid>
              </Grid>
            );
          })()}
        </CardContent>
      </Card>
      <TransitionDialog
        isOpen={isOpen}
        handleClose={handleCloseDialog}
        heading={"Are you sure you want to save the following charges?"}
        handleConfirm={handleConfirmDialog}
      >
        {dialogContent &&
          dialogContent?.split("#").map((data: any, index: any) => (
            <Box key={index}>
              <p style={{ lineHeight: "0.7" }}>{data}</p>
            </Box>
          ))}
      </TransitionDialog>

      <TransitionDialog
        isOpen={isOpenDeleteDailog}
        handleClose={handleCloseDeleteDialog}
        heading={"Confirmation"}
        handleConfirm={handleDeleteDialog}
      >
        Are you sure you want to delete this record?
      </TransitionDialog>

      <TransitionDialog
        isOpen={isOpenDublicateDailog}
        handleClose={handleCloseDublicateDialog}
        heading={"Confirmation"}
        handleConfirm={handleSaveDublicateDialog}
      >
        Record against vehicle already present in same trip, do you want to save another one?
      </TransitionDialog>
    </div>
  );
}
